// Virtuelle Standard-Config für eine Sprache eines Multi-Lingual-Projekts
// (Spec 2026-07-30). Der Dienst liefert die Config bereits sprachgefiltert;
// diese Funktion formt sie in die Standard-Form, mit der alle Downstream-
// Mechaniken (Stores, Blocks, Timeline, Upload, Filenames) unverändert
// arbeiten. Gibt null zurück bei unbekanntem Code oder Standard-Config.
import type { Asset, ProjectLanguage, ToolConfig } from '@shared/types';

export function deriveLanguageConfig(config: ToolConfig, lang: string): ToolConfig | null {
  if (config.projectType !== 'multilingual' || !config.languages) return null;
  const code = lang.toUpperCase();
  const language: ProjectLanguage | undefined =
    config.languages.find((l) => l.code.toUpperCase() === code);
  if (!language) return null;
  const voice = config.voices.find((v) => v.id === language.voiceId);
  return {
    ...config,
    languageCode: code,
    voices: voice ? [{ ...voice }] : [],
    assets: config.assets
      .filter((a) => a.scripts?.[code] != null)
      .map((a) => {
        const { scripts: _s, videoPaths, infos, models, ...rest } = a;
        const out: Asset = { ...rest, script: a.scripts![code]!, voiceIds: [language.voiceId] };
        // Overrides pro Sprache (Spec 2026-09-21): Key vorhanden = Override,
        // auch wenn leer. Felder nur anfassen, wenn global oder Override sie
        // setzen -- ein Alt-Record bleibt byte-identisch.
        if (videoPaths && code in videoPaths) out.videoPath = videoPaths[code] || null;
        if ('videoPath' in out || 'allowVideo' in out) out.allowVideo = !!out.videoPath;
        if (infos && code in infos) out.info = infos[code];
        if (models && code in models) out.model = models[code];
        return out;
      }),
    cloudPath: config.cloudPath ? `${config.cloudPath}/${encodeURIComponent(code)}` : encodeURIComponent(code),
    languages: undefined,
    allowCustomAssets: false,
    surveyPassword: null,
    _simpleMode: true,
  };
}
